import { LoanApplicationCapability } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/types/LoanApplicationCapability';
import { LoanApplicationMode } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/types/LoanApplicationMode';

export const loanApplicationEditModeMapper = (mode: LoanApplicationMode) => {
  const viewOnlyCapabilities = [LoanApplicationCapability.VIEW];
  const editContractSignatureCapabilities = [
    ...viewOnlyCapabilities,
    LoanApplicationCapability.SET_LENDER_REQUEST_ID,
    LoanApplicationCapability.CONTRACT_SIGNATURE_TO_BORROWER_SENDING,
    LoanApplicationCapability.SET_CONTRACT_SIGNED,
    LoanApplicationCapability.UN_SIGN_CONTRACT,
  ];
  const fullCapabilities = [
    LoanApplicationCapability.OPEN_PROCESS_RESPONSE_FOLDER,
    LoanApplicationCapability.CHANGE_LENDER_APPROVAL_STATUS,
    ...editContractSignatureCapabilities,
  ];

  switch (mode) {
    case LoanApplicationMode.VIEW_ONLY:
      return viewOnlyCapabilities;
    case LoanApplicationMode.EDIT_CONTRACT_SIGNATURE_AND_ID:
      return editContractSignatureCapabilities;
    case LoanApplicationMode.FULL:
      return fullCapabilities;
    default:
      return viewOnlyCapabilities;
  }
};
